module.exports = __webpack_public_path__ + "img/Modernisme_Norske_lyrikere2.3a607f31.jpg";